<!-- Middle Part -->
<div class="middle-part" *ngIf="!isReportVisible">
    <div class="clear"></div>
    <div class="container-fluid p-0">
        <!-- -- Reports start -- -->
        <div class="col-md-12 mb-4">
            <div class="row">
                <!-- first block start -->
                <div class="col-md-12 mt-3">
                    
                    <div class="white-content-area pb-3">
                        <div class="col-md-12">
                            <div class="col-md-8">
                                <h2 class="text-left fw-bold">Business Intelligence</h2>
                            </div>
                            <ngx-spinner name="dataLoader" [fullScreen]="false" type="timer" size="medium"></ngx-spinner>

                            <div class="col-md-12">

                                <mat-accordion>
                                    <mat-expansion-panel [expanded]="isFirst">
                                      <mat-expansion-panel-header>
                                        <mat-panel-title> Inbound Outbound WMS data </mat-panel-title>
                                      </mat-expansion-panel-header>
                                      <a class="mt-4" style="color:#00a1e1"
                                         href="javascript:void();" (click)="ReportVisible()">
                                         https://prod-useast-b.online.tableau.com/#/site/arcadiacold/views/UpcomingAppointments-WMS/AppointmentDetailData-Dashboard</a>
                                    </mat-expansion-panel>


                                    <mat-expansion-panel [expanded]="isFirst">
                                      <mat-expansion-panel-header>
                                        <mat-panel-title> AMS report </mat-panel-title>
                                      </mat-expansion-panel-header>
                                        <div>
                                            <a  class="mt-4" style="color:#00a1e1"
                                            href="javascript:void();" (click)="ReportVisibleAMS1()">
                                            https://prod-useast-b.online.tableau.com/#/site/arcadiacold/views/UpcomingAppointments-WMS/DashboardInformation?:iid=4
                                            </a>
                                        </div>
                                      
                                        <div>
                                            <a  class="mt-4" style="color:#00a1e1"
                                            href="javascript:void();" (click)="ReportVisibleAMS2()">
                                            https://prod-useast-b.online.tableau.com/#/site/arcadiacold/views/UpcomingAppointments-WMS/AppointmentDetailData-Dashboard
                                            </a>
                                        </div>
                                      
                                    </mat-expansion-panel>
                                    <mat-expansion-panel [expanded]="isFirst">
                                        <mat-expansion-panel-header>
                                          <mat-panel-title> New Links June 2025 </mat-panel-title>
                                        </mat-expansion-panel-header>
                                          <div>
                                              <a  class="mt-4" style="color:#00a1e1"
                                              href="javascript:void();" (click)="ReportVisibleJune1()">
                                              https://prod-useast-b.online.tableau.com/#/site/arcadiacold/workbooks/2768678/views
                                              </a>
                                          </div>
                                        
                                          <div>
                                              <a  class="mt-4" style="color:#00a1e1"
                                              href="javascript:void();" (click)="ReportVisibleJune2()">
                                              https://prod-useast-b.online.tableau.com/#/site/arcadiacold/workbooks/2771750/views
                                              </a>
                                          </div>
                                          <div>
                                            <a  class="mt-4" style="color:#00a1e1"
                                            href="javascript:void();" (click)="ReportVisibleJune3()">
                                            https://prod-useast-b.online.tableau.com/#/site/arcadiacold/views/WarehouseCustomerOccupancyandInboundOutboundtrends/Dashboard6?:iid=1
                                            </a>
                                        </div>
                                        <div>
                                            <a  class="mt-4" style="color:#00a1e1"
                                            href="javascript:void();" (click)="ReportVisibleJune4()">
                                            https://prod-useast-b.online.tableau.com/#/site/arcadiacold/views/WarehouseCustomerOccupancyandInboundOutboundtrends/inboundsandoutbounds2?:iid=1
                                            </a>
                                        </div>
                                        
                                      </mat-expansion-panel>

                                      <mat-expansion-panel [expanded]="isFirst">
                                        <mat-expansion-panel-header>
                                          <mat-panel-title>  June 11, 2025 </mat-panel-title>
                                        </mat-expansion-panel-header>
                                          <div>
                                              <a  class="mt-4" style="color:#00a1e1"
                                              href="javascript:void();" (click)="ReportVisibleAJune11()">
                                              Warehouse Customer Dispatch Dashboard
                                              </a>
                                          </div>
                                        
                                          <div>
                                              <a  class="mt-4" style="color:#00a1e1"
                                              href="javascript:void();" (click)="ReportVisibleBJune11()">
                                              Warehouse Customer Occupancy and InboundOutbound Trends Dashboard
                                              </a>
                                          </div>
                                        
                                      </mat-expansion-panel>
                                </mat-accordion>
                            </div>
                            
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div *ngIf="isInboundOutboundReportVisible">
     <div class="mt-3 back-button">
        <button class="btn btn-md back-button-css" (click)="resetAllViews()"><i
            class="fa fa-arrow-left mr-1" aria-hidden="true"></i>Back</button>
    </div>
    <tableau-viz id="tableau-viz" src="https://prod-useast-b.online.tableau.com/#/site/arcadiacold/views/UpcomingAppointments-WMS/AppointmentDetailData-Dashboard"
     token={{tokenKey}}
     width="100%"
     height="1004"
     toolbar="bottom">
    </tableau-viz>
</div>

<div *ngIf="isAMSReportVisible1">
    <div class="mt-3 back-button">
        <button class="btn btn-md back-button-css" (click)="resetAllViews()"><i
            class="fa fa-arrow-left mr-1" aria-hidden="true"></i>Back</button>
    </div>
    <tableau-viz id="tableau-viz" src="https://prod-useast-b.online.tableau.com/#/site/arcadiacold/views/UpcomingAppointments-WMS/DashboardInformation?:iid=4"
     token={{tokenKey}}
     width="100%"
     height="1004"
     toolbar="bottom">
    </tableau-viz>
</div>


<div *ngIf="isAMSReportVisible2">
    <div class="mt-3 back-button">
        <button class="btn btn-md back-button-css" (click)="resetAllViews()"><i
            class="fa fa-arrow-left mr-1" aria-hidden="true"></i>Back</button>
    </div>
    <tableau-viz id="tableau-viz" src="https://prod-useast-b.online.tableau.com/#/site/arcadiacold/views/UpcomingAppointments-WMS/AppointmentDetailData-Dashboard"
     token={{tokenKey}}
     width="100%"
     height="1004"
     toolbar="bottom">
    </tableau-viz>
</div>

<div *ngIf="isJune2025Visible1">
    <div class="mt-3 back-button">
        <button class="btn btn-md back-button-css" (click)="resetAllViews()"><i
            class="fa fa-arrow-left mr-1" aria-hidden="true"></i>Back</button>
    </div>
    <tableau-viz id="tableau-viz" src="https://prod-useast-b.online.tableau.com/#/site/arcadiacold/workbooks/2768678/views"
     token={{tokenKey}}
     width="100%"
     height="1004"
     toolbar="bottom">
    </tableau-viz>
</div>

<div *ngIf="isJune2025Visible2">
    <div class="mt-3 back-button">
        <button class="btn btn-md back-button-css" (click)="resetAllViews()"><i
            class="fa fa-arrow-left mr-1" aria-hidden="true"></i>Back</button>
    </div>
    <tableau-viz id="tableau-viz" src="https://prod-useast-b.online.tableau.com/#/site/arcadiacold/workbooks/2771750/views"
     token={{tokenKey}}
     width="100%"
     height="1004"
     toolbar="bottom">
    </tableau-viz>
</div>

<div *ngIf="isJune2025Visible3">
     <div class="mt-3 back-button">
        <button class="btn btn-md back-button-css" (click)="resetAllViews()"><i
            class="fa fa-arrow-left mr-1" aria-hidden="true"></i>Back</button>
    </div>
    <tableau-viz id="tableau-viz" src="https://prod-useast-b.online.tableau.com/#/site/arcadiacold/views/WarehouseCustomerOccupancyandInboundOutboundtrends/Dashboard6?:iid=1"
     token={{tokenKey}}
     width="100%"
     height="1004"
     toolbar="bottom">
    </tableau-viz>
</div>

<div *ngIf="isJune2025Visible4">
    <div class="mt-3 back-button">
        <button class="btn btn-md back-button-css" (click)="resetAllViews()"><i
            class="fa fa-arrow-left mr-1" aria-hidden="true"></i>Back</button>
    </div>
    <tableau-viz id="tableau-viz" src="https://prod-useast-b.online.tableau.com/#/site/arcadiacold/views/WarehouseCustomerOccupancyandInboundOutboundtrends/inboundsandoutbounds2?:iid=1"
     token={{tokenKey}}
     width="100%"
     height="1004"
     toolbar="bottom">
    </tableau-viz>
</div>

<div *ngIf="isJune112025Visible1">
    <div class="mt-3 back-button">
        <button class="btn btn-md back-button-css" (click)="resetAllViews()"><i
            class="fa fa-arrow-left mr-1" aria-hidden="true"></i>Back</button>
    </div>
    <tableau-viz id="tableau-viz" src="https://prod-useast-b.online.tableau.com/t/arcadiacold/views/WarehouseCustomerDispatchDashboard_17478359351170/UserFilter"
     token={{tokenKey}}
     width="100%"
     height="1004"
     toolbar="bottom">
    </tableau-viz>
</div>

<div *ngIf="isJune112025Visible2">
    <div class="mt-3 back-buttton" style="text-align: end;
    margin-right: 50px;
    margin-bottom: 20px;">
        <button class="btn btn-md back-button-css" (click)="resetAllViews()"><i
            class="fa fa-arrow-left mr-1" aria-hidden="true"></i>Back</button>
    </div>
    <tableau-viz id="tableau-viz" src="https://prod-useast-b.online.tableau.com/t/arcadiacold/views/WarehouseCustomerOccupancyandInboundOutboundtrends/Dashboard6"
     token={{tokenKey}}
     width="100%"
     height="1004"
     toolbar="bottom">
    </tableau-viz>
</div>
